/** Query filters for `GET .../asset-ropa/mine/` and `GET .../asset-ropa/` (AssetRopaOwnerFilterSet). */
export type AssetRopaOwnerFilterCompleteness = 'complete' | 'incomplete' | 'no_processing_activities';

export type AssetRopaOwnerFilterGdprRelevance = 'all' | 'currently_indicated' | 'no_longer_indicated';

export type AssetRopaOwnerFilterParams = {
  asset_type?: number;
  completeness?: AssetRopaOwnerFilterCompleteness;
  dpia_indication?: boolean;
  dpia_request_status?: string;
  dpia_status?: string;
  gdpr_relevance?: AssetRopaOwnerFilterGdprRelevance;
  page?: number;
  page_size?: number;
  search?: string;
  sensitive_data?: boolean;
  third_country?: boolean;
};

export const DEFAULT_ASSET_ROPA_OWNER_PAGE_SIZE = 50;
